"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var Input_1 = require("../Input/Input");

var InputGroup_1 = require("../InputGroup/InputGroup");

var Select_1 = require("../Select/Select");

var handleEvent_1 = require("../assets/handleEvent");

var withField_1 = require("../decorators/withField");

var inputAttrs_1 = require("../assets/inputAttrs");

var isInvalid_1 = require("../channels/isInvalid");

var DEFAULT_DOMAINS = ['@mail.ru', '@inbox.ru', '@list.ru', '@corp.mail.ru', '@bk.ru'];

var Email =
/** @class */
function (_super) {
  __extends(Email, _super);

  function Email() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      showDomains: _this.props.strictDomains || _this.defaultShowDomains()
    };

    _this.onEmailChange = function (value) {
      var _a = _this.props,
          onChange = _a.onChange,
          onDomainsShowChange = _a.onDomainsShowChange;

      if (value.indexOf('@') < 0) {
        _this.setState({
          showDomains: true
        }, function () {
          handleEvent_1.handleEvent(onDomainsShowChange, true);

          _this.generateChange({
            login: value,
            domain: _this.domains[0]
          });
        });

        return;
      }

      handleEvent_1.handleEvent(onChange, value);
    };

    _this.onLoginChange = function (value) {
      var _a = _this.props,
          onChange = _a.onChange,
          onDomainsShowChange = _a.onDomainsShowChange,
          strictDomains = _a.strictDomains;

      if (strictDomains && value.indexOf('@') > -1) {
        value = value.replace(/@/g, '');
      }

      if (value.indexOf('@') > -1) {
        _this.setState({
          showDomains: false
        }, function () {
          return handleEvent_1.handleEvent(onDomainsShowChange, false);
        });

        handleEvent_1.handleEvent(onChange, value);
      } else {
        _this.generateChange({
          login: value
        });
      }
    };

    _this.onDomainChange = function (domain) {
      return _this.generateChange({
        domain: domain
      });
    };

    return _this;
  }

  Object.defineProperty(Email.prototype, "domains", {
    get: function get() {
      return this.props.domains || DEFAULT_DOMAINS;
    },
    enumerable: true,
    configurable: true
  });

  Email.prototype.render = function () {
    return React.createElement(InputGroup_1.default, __assign({}, this.props), this.renderInput(), this.renderDomains());
  };

  Email.prototype.renderDomains = function () {
    if (!this.state.showDomains) {
      return;
    }

    var _a = this.props,
        domainName = _a.domainName,
        testId = _a.testId,
        id = _a.id,
        invalid = _a.invalid;
    return React.createElement(Select_1.default, {
      inline: true,
      name: domainName,
      options: this.domains,
      value: this.getDomain() || this.domains[0],
      onChange: this.onDomainChange,
      testId: testId && testId + "__select",
      id: id && id + "__select",
      invalid: invalid,
      menuContainer: this.props.menuContainer,
      menuContainerTestId: this.props.menuContainerTestId,
      onFocus: this.props.onDomainsFocus,
      onBlur: this.props.onDomainsBlur,
      ref: this.props.domainsRef
    });
  };

  Email.prototype.generateChange = function (parts) {
    var onChange = this.props.onChange;

    var fullParts = __assign(__assign({}, this.parseEmail()), parts);

    var domain = fullParts.domain;
    var login = fullParts.login;

    if (this.state.showDomains && !domain) {
      domain = this.domains[0];
    }

    var email = "" + login + domain;
    handleEvent_1.handleEvent(onChange, email);
  };

  Email.prototype.defaultShowDomains = function () {
    var domain = this.getDomain();

    if (domain.length && this.domains.some(function (el) {
      return el === domain;
    })) {
      return true;
    }

    return !this.getLogin();
  };

  Email.prototype.getLogin = function () {
    return this.parseEmail().login;
  };

  Email.prototype.getDomain = function () {
    return this.parseEmail().domain;
  };

  Email.prototype.parseEmail = function () {
    var _a = (this.props.value || '').split('@'),
        login = _a[0],
        domain = _a[1],
        rest = _a.slice(2);

    return {
      domain: domain && !rest.length ? "@" + domain : '',
      login: login || ''
    };
  };

  Email.prototype.renderInput = function () {
    var _a = this.props,
        value = _a.value,
        name = _a.name,
        loginName = _a.loginName,
        testId = _a.testId,
        id = _a.id,
        invalid = _a.invalid;
    var showDomains = this.state.showDomains;
    var inputTestId = testId && testId + "__input";
    var inputId = id && id + "__input";
    var props = showDomains ? __assign(__assign({}, inputAttrs_1.inputAttrs(this.props)), {
      onChange: this.onLoginChange,
      value: this.getLogin(),
      type: 'text',
      name: loginName || name,
      testId: inputTestId,
      id: inputId,
      invalid: invalid
    }) : __assign(__assign({}, inputAttrs_1.inputAttrs(this.props)), {
      name: name,
      value: value,
      onChange: this.onEmailChange,
      type: 'email',
      testId: inputTestId,
      id: inputId,
      invalid: invalid
    });
    return React.createElement(Input_1.default, __assign({}, props));
  };

  Email = __decorate([isInvalid_1.withIsInvalid(isInvalid_1.mapIsInvalidToProps), withField_1.withField], Email);
  return Email;
}(React.Component);

exports.default = Email;